import React, { useState } from "react";
import "react-phone-input-2/lib/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/enquiry.css"
import { useNavigate } from "react-router";

const EnquiryForm = ({ productName, onClose }) => {
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [location, setLocation] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = {
      productName,
      name,
      location,
      phone,
      email,
    };

    fetch("https://api.mytimewatch.com/api/enquiry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Enquiry submitted successfully:", data);
        setIsSubmitting(false);

        
        onClose();
        navigate("/thank-you");
      })
      .catch((error) => {
        console.error("Error submitting enquiry:", error);
        setIsSubmitting(false);
      });
  };

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center" style={{borderBottom: 'none'}}>
            <h5 className="modal-title">Enquire Now</h5>
            <button
              type="button"
              className="close fw-bold fs-2"
              onClick={onClose}
              aria-label="Close"
              style={{
                border: "none",
                backgroundColor: "transparent",
                color: "#f14144",
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            
              <form onSubmit={handleSubmit} className="container-fluid">
                <div className="form-group mb-3">
                  <label>Product Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={productName}
                    readOnly
                    style={{
                      cursor: "not-allowed",
                      backgroundColor: "#f9f9f9",
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Location</label>
                  <input
                    type="text"
                    className="form-control"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    required
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Email ID</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-danger btn-block mt-3 mx-auto d-block" disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </form>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryForm;
